import _ from 'lodash'

import {
  LegacyPage,
  Model,
  LoadingContainer,
  Panels,
  Bar,
  MiniTable,
} from 'peach/components'
import { humanizeKey } from 'peach/helpers'
import { useParams, useRouteMatch, Link } from 'peach/router'

import {
  useInternalListTemplateDescriptors,
  useInternalListTemplateVersionsModern,
} from 'core/types'

const TemplateSubject = () => {
  const { url } = useRouteMatch()
  const { companyId, subjectKey } = useParams<{
    companyId?: string
    subjectKey?: string
  }>()

  const {
    data: descriptorsList,
    isLoading: descriptorsLoading,
    error: descriptorsError,
  } = useInternalListTemplateDescriptors({
    companyId,
  })

  const {
    data: templatesList,
    isLoading: templatesLoading,
    error: templatesError,
  } = useInternalListTemplateVersionsModern({
    companyId,
  })

  const descriptors = _.filter(descriptorsList, { subject: subjectKey })
  const descriptorIds = _.map(descriptors, 'id')

  const templates = _.filter(templatesList, ({ descriptorId }) =>
    _.includes(descriptorIds, descriptorId),
  )

  const rows = _.map(descriptors, (descriptor) => {
    const { channel, language, sensitive } = descriptor
    return (
      <MiniTable.Row key={channel}>
        <Link to={`${url}/${channel}`}>{humanizeKey(channel)}</Link>
        {language}
        {sensitive ? 'True' : 'False'}
      </MiniTable.Row>
    )
  })

  return (
    <LoadingContainer
      error={descriptorsError || templatesError}
      isLoading={descriptorsLoading || templatesLoading}
    >
      <Panels header={<Bar title={humanizeKey(subjectKey)} />}>
        <LegacyPage.Full>
          <MiniTable columns={['Channel', 'Language', 'Sensitive']}>
            {rows}
          </MiniTable>
          <Model.List json={descriptors} noLink title='Descriptors' />
          <Model.List json={templates} noLink title='Templates' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default TemplateSubject
